module.exports = __webpack_public_path__ + "img/sie-logo-claim-white-rgb.2b0e309c.png";